import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { masterclassQKeys } from "@hooks/queries/masterclass/queryKeys";

export const useDeleteMasterclass = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.delete(`masterclass/${id}/`);
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Masterclass deleted successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: masterclassQKeys.classes(),
      });
    },
    onError: (res: any) => {
      console.error("[From Delete Masterclass Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
